module.exports = __webpack_public_path__ + "static/media/bristol-myers.018ed5cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/bristol-myers.png
// module id = 122
// module chunks = 0